import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useSeo } from "../lib/hooks";

const inline = (text) =>
  text.split(/(\[À compléter[^\]]*\])/g).map((part, i) => (part.startsWith("[À compléter") ? <span key={i} className="placeholder-field">{part}</span> : part));

export const RichText = ({ content }) => {
  const blocks = [];
  let list = [];
  const flush = () => { if (list.length) { blocks.push(<ul key={blocks.length}>{list.map((l, i) => <li key={i}>{inline(l)}</li>)}</ul>); list = []; } };
  content.split("\n").forEach((raw) => {
    const line = raw.trim();
    if (line.startsWith("- ")) { list.push(line.slice(2)); return; }
    flush();
    if (line.startsWith("## ")) blocks.push(<h2 key={blocks.length}>{line.slice(3)}</h2>);
    else if (line) blocks.push(<p key={blocks.length}>{inline(line)}</p>);
  });
  flush();
  return <div className="prose-legal">{blocks}</div>;
};

export default function LegalPage({ page }) {
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); api.get(`/pages/${page}`).then((r) => setData(r.data)).catch(() => setData(false)); }, [page]);
  useSeo({ title: data?.title || "Informations", description: data ? `${data.title} — NasDeal.` : undefined });
  if (data === null) return <p className="py-32 text-center eyebrow">Chargement…</p>;
  if (!data) return <p className="py-32 text-center font-display text-3xl">Page introuvable</p>;
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-20" data-testid={`legal-page-${page}`}>
      <p className="eyebrow mb-4">Informations</p>
      <h1 className="font-display text-4xl sm:text-5xl">{data.title}</h1>
      {!data.validated && (
        <p className="mt-6 text-xs border border-dashed border-[#C9A45C]/40 p-4 text-[#F8F6F1]/60" data-testid="legal-template-notice">
          Version provisoire en attente de validation. Les éléments encadrés en or restent à compléter.
        </p>
      )}
      <div className="mt-4"><RichText content={data.content} /></div>
    </div>
  );
}
